import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import RootRef from '@material-ui/core/RootRef';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import EraActionsTableEmpty from './EraActionsTableEmpty';
import EraActionsTableRow from './EraActionsTableRow';

const styles = theme => ({
  paper: {
    position: 'relative',
    width: '100%',
    height: 'calc(100vh - 250px)',
    overflowX: 'auto',
    overflowY: 'visible',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 178px)',
      transition: theme.transitions.create(['height'], {
        duration: theme.transitions.duration.short,
      }),
    },
  },
  paperMobileFilterExpanded: {
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 268px)',
    },
  },
  typography: {
    paddingLeft: 10,
    paddingBottom: 8,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  table: {
    minWidth: 500,
  },
  hiddenCell: {
    fontSize: 0,
  },
  tableHead: {
    position: 'sticky',
    zIndex: 20,
    top: 0,
    '& th:first-child': {
      borderTopLeftRadius: 10,
    },
    '& th:last-child': {
      borderTopRightRadius: 10,
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      height: 56,
      left: -8,
      right: -8,
      top: 0,
      zIndex: -1,
      backgroundColor: theme.palette.grey[100],
    },
    '& th': {
      position: 'relative',
      zIndex: 1,
    },
  },
});

const EraActionsTable = ({
  items,
  count,
  classes,
  loading,
  mobileFilterExpanded,
  onScroll,
  scrollRef,
}) => (
  <div>
    {(loading === 0 || items.length > 0) && (
      <Typography className={classes.typography}>
        {`(${count})`}
      </Typography>
    )}
    <RootRef rootRef={scrollRef}>
      <Paper
        className={classNames(classes.paper, {
          [classes.paperMobileFilterExpanded]: mobileFilterExpanded,
        })}
        onScroll={onScroll}
      >
        {(loading === 0 && items.length === 0) &&
          <EraActionsTableEmpty />
        }
        {items.length > 0 &&
          <Table className={classes.table}>
            <TableHead
              className={classes.tableHead}
            >
              <TableRow>
                <TableCell>Group</TableCell>
                <TableCell>Code</TableCell>
                <TableCell>Action</TableCell>
                <TableCell className={classes.hiddenCell}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map(item => (
                <EraActionsTableRow
                  key={item.ID}
                  {...item}
                />
              ))}
            </TableBody>
          </Table>
        }
      </Paper>
    </RootRef>
  </div>
);

EraActionsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.number,
  mobileFilterExpanded: PropTypes.bool,
  onScroll: PropTypes.func,
  scrollRef: PropTypes.func,
  classes: PropTypes.shape({
    paper: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
    hiddenCell: PropTypes.string.isRequired,
  }).isRequired,
};

EraActionsTable.defaultProps = {
  loading: 0,
  mobileFilterExpanded: false,
  onScroll: undefined,
  scrollRef: undefined,
};

export default withStyles(styles)(EraActionsTable);



// WEBPACK FOOTER //
// ./src/components/settings/EraActionsTable/EraActionsTable.js